import {ObjectBuilder, BigWinView, MovieClip} from '@gongxigames/framework/slot';
import {Layer} from '@pixi/layers';
import {LAYERS} from '@gongxigames/framework/slot';
import {Sprite, Texture} from 'pixi.js';

export class GameBigWinView extends BigWinView {
    public static readonly NON_ASIAN_PARTICLE_TYPES: any = {
        amazing: ['ruby_coin'],
        incredible: ['ruby_coin', 'emerald'],
        awesome: ['ruby_coin', 'emerald', 'ruby']
    };

    protected initParticles(): void {
        this._particles = this.objectBuilder.buildSprite(ObjectBuilder.resources.shared_sprite.bigWinParticlesNonAsian);
        this._particles.visible = false;
        this.container.addChild(this._particles);
    }

    protected needAddParticleType(item: MovieClip): boolean {
        return GameBigWinView.NON_ASIAN_PARTICLE_TYPES[this._BWType].indexOf(item.name) >= 0;
    }

    protected addParticlesEmitterToSlot(): void {
        const slotSprite = this._spine.skeleton.findSlot('emitter').currentSprite;
        const sprite = new Sprite;

        sprite.scale.set(1);
        sprite.x = -sprite.getLocalBounds().width / 2;
        sprite.y = -sprite.getLocalBounds().height / 2;
        slotSprite.texture = Texture.EMPTY;
        slotSprite.addChild(sprite);
        this._particlesContainer = sprite;
    }

    public static layer: Layer = LAYERS.POPUPS;
}
